import React, { useEffect, useState } from 'react'

import { BlockPicker, ColorState } from 'react-color'
import styled from 'styled-components'

import plusIconUrl from 'app/assets/icons/add_24px.svg'
import closeIcon from 'app/assets/icons/close_24px.svg'
import { Box, IconBox } from 'app/components/design-system-components'

interface SelectColorProps {
  $backgroundColor: React.CSSProperties['backgroundColor']
}

const SelectColorBox = styled(Box)<SelectColorProps>`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #cccccc;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  cursor: pointer;
`

const StyledIconBox = styled(IconBox)`
  position: absolute;
  z-index: 2;
  top: -12px;
  right: -12px;
  cursor: pointer;
  background-color: white;
  border-radius: 100%;
`

const SelectColor = ({
  onChangeCustom,
  id,
  defaultValue,
  onDelete,
  disabled,
}: any) => {
  const [colorValue, setColorValue] = useState('')
  const [displayColorPicker, setDisplayColorPicker] = useState(false)
  const [isHovered, setIsHovered] = useState<boolean>(false)

  const handleChange = (colorState: ColorState) => {
    if (disabled) {
      return
    }

    if (!onChangeCustom) {
      setColorValue(colorState.hex)
    }

    onChangeCustom?.({ value: colorState, setColorValue, handleClose })
  }

  const handleClick = () => {
    !disabled && setDisplayColorPicker((prev) => !prev)
  }

  const handleClose = () => {
    setDisplayColorPicker(false)
  }

  useEffect(() => {
    if (defaultValue) {
      setColorValue(defaultValue)
    }
  }, [defaultValue])

  const popover = {
    position: 'absolute',
    zIndex: '2',
    top: '42px',
    left: '-70px',
  }

  const cover = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  }
  return (
    <Box position={'relative'}>
      {colorValue ? (
        <Box
          position="relative"
          onMouseEnter={() => !disabled && setIsHovered(true)}
          onMouseLeave={() => !disabled && setIsHovered(false)}
        >
          <SelectColorBox
            onClick={handleClick}
            id={id}
            $backgroundColor={colorValue}
          />
          {isHovered && (
            <StyledIconBox
              className="icon"
              onClick={(e: Event) => {
                e.stopPropagation()
                !disabled && onDelete()
              }}
            >
              <img src={closeIcon} alt="dismiss" />
            </StyledIconBox>
          )}
        </Box>
      ) : (
        <IconBox size={32} onClick={handleClick}>
          <img alt="" src={plusIconUrl} />
        </IconBox>
      )}

      {displayColorPicker ? (
        <Box style={popover}>
          <Box style={cover} onClick={handleClose} />
          <BlockPicker
            onChangeComplete={handleChange}
            color={colorValue}
            colors={[
              '#1AB25D',
              '#FF5B77',
              '#697689',
              '#37D67A',
              '#2CCCE4',
              '#555555',
              '#dce775',
              '#ff8a65',
              '#ba68c8',
            ]}
          />
        </Box>
      ) : null}
    </Box>
  )
}

export default SelectColor
